import { render, staticRenderFns } from "./AppToolsForcePosSale.vue?vue&type=template&id=36b2777c"
import script from "./AppToolsForcePosSale.vue?vue&type=script&lang=ts"
export * from "./AppToolsForcePosSale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports